export const chartReviewContainerSx = {
  width: '100%',
  overflow: 'hidden',
  backgroundColor: '#fff',
  borderRadius: 0
};

export const chartReviewHeaderSx = {
  height: 46,
  display: 'flex',
  alignItems: 'center',
  px: 2,
  backgroundColor: '#F7F9FC',
  borderBottom: '1px solid #E0E0E0'
};

export const chartReviewTitleSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#424242',
  textTransform: 'uppercase'
};

export const commonTableSx = {
  tableLayout: 'fixed',

  '& .MuiTableCell-root': {
    color: '#424242',
    borderBottom: '1px solid #EEEEEE'
  },

  '& .MuiTableRow-root': {
    height: 38
  }
};

export const commonTableHeadRowSx = {
  backgroundColor: '#FAFAFA'
};

export const commonTableBodyRowSx = {
  '&:hover': {
    backgroundColor: '#FCF8F2'
  }
};

export const commonHeadCellSx = {
  height: 40,
  padding: '0 18px',
  fontSize: 12,
  fontWeight: 500,
  color: '#424242',
  letterSpacing: 0,
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  backgroundColor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0'
};

export const commonBodyCellSx = {
  height: 40,
  padding: '0 18px',
  overflow: 'hidden',
  fontSize: 12,
  fontWeight: 400,
  color: '#424242',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  borderBottom: '1px solid #EEEEEE'
};